import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getPartyRateList = createAsyncThunk(
  "get-supplier-rate",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("supplier-rate/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const createPartyRate = createAsyncThunk(
  "create-supplier-rate",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("supplier-rate", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const updatePartyRate = createAsyncThunk(
  "update-supplier-rate",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/supplier-rate/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

// Deliberately has no extraReducers case: the import dialog uses it to read a
// party's current rates for the sample sheet, and touching `loading` here would
// swap the page behind it for a <Loader /> and unmount the dialog.
export const getPartyRatesByParty = createAsyncThunk(
  "get-supplier-rate-by-party",
  async (supplierId, { dispatch }) => {
    try {
      const response = await axios.get("supplier-rate/list", {
        params: { supplierId },
      });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const importPartyRate = createAsyncThunk(
  "import-supplier-rate",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("supplier-rate/import", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

// Product Wise Price screen: several vendors' prices for one product, saved
// together in one call so they all land or none do.
export const bulkUpdatePartyRatePrice = createAsyncThunk(
  "bulk-update-party-rate-price",
  async (data, { dispatch }) => {
    try {
      const response = await axios.patch("supplier-rate/bulk-price", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const deletePartyRate = createAsyncThunk(
  "delete-supplier-rate",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/supplier-rate/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

const partyRateSlice = createSlice({
  name: "partyRate",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPartyRateList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPartyRateList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.supplierRateList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getPartyRateList.rejected, (state) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default partyRateSlice.reducer;

